import Marionette from 'backbone.marionette';
import mentionItemviewTmpl from '../templates/bill_search_mention_itemview.tpl';
export default Marionette.ItemView.extend({
  template: mentionItemviewTmpl,
  tagName: 'li',
  className: "search-excerpt"
});